// eslint-disable-next-line import/prefer-default-export
export const BODY_CLASS_NAME_MOBILE_MENU = 'dt-mobile-block-scroll';
